module.exports = __webpack_public_path__ + "64ebc1e2cf1c32a856b0adf14c465ab1.pdf";